<script setup lang="ts">
  import { computed } from 'vue'
  import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-vue-next'
  import { TableCell } from '@/components/ui/table'

  const props = defineProps<{
    /** The field name used for sorting (e.g., 'created_at') */
    field: string
    /** Current sort value (e.g., '-created_at' for desc, 'created_at' for asc) */
    currentSort: string
    /** Additional CSS classes for the TableCell */
    class?: string
  }>()

  const emit = defineEmits<{
    sort: [field: string, direction: 'asc' | 'desc']
  }>()

  const sortState = computed(() => {
    if (props.currentSort === `-${props.field}`) return 'desc'
    if (props.currentSort === props.field) return 'asc'
    return 'none'
  })

  const handleClick = () => {
    // Cycle: none -> desc -> asc -> desc
    const nextDirection = sortState.value === 'desc' ? 'asc' : 'desc'
    emit('sort', props.field, nextDirection)
  }
</script>

<template>
  <TableCell
    :class="['cursor-pointer select-none py-3 transition-colors hover:bg-gray-100', props.class]"
    @click="handleClick"
  >
    <div class="flex items-center gap-2">
      <slot />
      <ArrowUp
        v-if="sortState === 'asc'"
        class="h-4 w-4 flex-shrink-0 text-gray-700"
      />
      <ArrowDown
        v-else-if="sortState === 'desc'"
        class="h-4 w-4 flex-shrink-0 text-gray-700"
      />
      <ArrowUpDown
        v-else
        class="h-4 w-4 flex-shrink-0 text-gray-400"
      />
    </div>
  </TableCell>
</template>
